import {
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const rootRouteRef = createRouteRef();
export const siteRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/:name',
});
export const adminAnalyticsRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/admin/analytics',
});
export const adminCustomDomainsRouteRef = createSubRouteRef({
  parent: rootRouteRef,
  path: '/admin/custom-domains',
});
